import React from "react";
import { Divider, Stack, Typography } from "@mui/material";
import HyroTooltipSection from "@hyro-components/hyro-tooltip-section/HyroTooltipSection";
import palette from "src/theme/palette";
import { CHANNEL_META, INTERACTIONS_SUFFIX, SKILLS_TOOLTIP_LABEL } from "./SubscriptionTab.consts";
import { LegendDot } from "./QuotaUsageSummary.styles";
import { buildSkillsBreakdown } from "./UsageOverTime.utils";

// Channel hover tooltip: channel → engaged total → top skills + Other.
// `skills` undefined = breakdown not loaded (flag off / still fetching / failed) → the skills block is omitted.
const ChannelSkillsTooltipContent = ({ channelType, engaged = 0, skills }) => {
  const meta = CHANNEL_META[channelType];
  const breakdown = skills ? buildSkillsBreakdown(skills, engaged) : [];

  return (
    <Stack gap={1} data-testid={`channel-tooltip-${channelType}`}>
      <Stack direction="row" alignItems="center" gap={1}>
        <LegendDot color={meta.color} />
        <Typography variant="tooltip" sx={{ color: palette.text[800] }}>{meta.label}</Typography>
      </Stack>
      <Divider sx={{ borderColor: palette.system[200] }} />
      <Stack gap={1}>
        <Typography variant="tooltip" sx={{ color: palette.text[600] }}>{meta.tooltip}</Typography>
        <Typography variant="tooltip" sx={{ color: palette.text[700] }}>
          {engaged.toLocaleString()} {INTERACTIONS_SUFFIX}
        </Typography>
      </Stack>
      {breakdown.length > 0 && (
        <Stack gap={1} data-testid={`channel-tooltip-${channelType}-skills`}>
          <HyroTooltipSection
            title={SKILLS_TOOLTIP_LABEL}
            rows={breakdown.map((skill) => ({ label: skill.name, value: `${skill.engaged.toLocaleString()} (${skill.pct})` }))}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default ChannelSkillsTooltipContent;
